import { SPXAPI } from '../interfaces';
import { LinkAuthFlow } from '../../types/types';
import { BASEURL, ENDPOINTS } from '../endpoints';

const getLinkAuthFlow = async (API: SPXAPI, linkId: string): Promise<LinkAuthFlow> => (
    API.get(BASEURL.backend(), ENDPOINTS.getLinkAuthFlow(linkId), {})
);

export default getLinkAuthFlow;
